import { SnackbarProvider } from "./SnackbarProvider";
import { UserProvider } from "./UserProvider";

const Providers = ({ children }) => {
  return (
    <UserProvider>
      <SnackbarProvider>{children}</SnackbarProvider>
    </UserProvider>
  );
};

export default Providers;
